import { addSelectedCalendar } from 'owa-calendar-module-selected-calendars-user-config';
import { getDefaultCalendar } from 'owa-calendar-cache';
import { isWorkLifeViewEnabledForUser } from 'owa-calendar-worklifeviewoption';

export function autoSelectDefaultCalendar(userIdentity: string) {
    // Auto-select default calendar if nothing is selected
    // do this only if corresponding work/life view is enabled in user options
    if (isWorkLifeViewEnabledForUser(userIdentity)) {
        const defaultCalendar = getDefaultCalendar(userIdentity);
        if (defaultCalendar) {
            addSelectedCalendar(defaultCalendar.id.id, userIdentity);
        }
    }
}
